import React from 'react';

export const TextSkeleton = ({ width = 'full', className = '' }) => (
  <div className={`h-4 bg-gray-100 rounded w-${width} ${className}`}></div>
);

export const ImageSkeleton = ({ className = '' }) => (
  <div className={`aspect-video bg-gray-100 rounded-lg ${className}`}></div>
);

export const CardSkeleton = () => (
  <div className="bg-white p-6 rounded-lg shadow-sm animate-pulse">
    <div className="h-12 w-12 bg-gray-100 rounded-lg mb-4"></div>
    <TextSkeleton width="3/4" className="mb-2" />
    <TextSkeleton width="1/2" />
  </div>
);

export const PageSkeleton = ({ type = 'default' }) => {
  switch (type) {
    case 'admin':
      return (
        <div className="animate-pulse">
          <div className="h-16 bg-gray-100 mb-8"></div>
          <div className="max-w-7xl mx-auto px-4">
            <TextSkeleton width="1/4" className="mb-8" />
            <div className="grid md:grid-cols-3 gap-6">
              <CardSkeleton />
              <CardSkeleton />
              <CardSkeleton />
            </div>
          </div>
        </div>
      );

    case 'website':
      return (
        <div className="animate-pulse">
          <div className="h-20 bg-gray-100 mb-8"></div>
          <div className="max-w-7xl mx-auto px-4">
            <div className="h-64 bg-gray-100 rounded-lg mb-12"></div>
            <div className="space-y-8">
              <TextSkeleton width="3/4" />
              <TextSkeleton width="1/2" />
              <TextSkeleton width="5/6" />
            </div>
          </div>
        </div>
      );

    default:
      return (
        <div className="animate-pulse">
          <div className="max-w-7xl mx-auto px-4">
            <TextSkeleton width="1/3" className="mb-6" />
            <div className="space-y-4">
              <TextSkeleton />
              <TextSkeleton width="5/6" />
              <TextSkeleton width="4/6" />
            </div>
          </div>
        </div>
      );
  }
};

export default PageSkeleton;